import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import CouponItem from './CouponItem.vue';
import { getPromotionStatusByPromotionIds, getPromotionInfosByPromotionIds, redeemPromotionForCurrentCustomer } from '@/models/api/promotionApi';
import { convertListToQueryParameter } from '@/utils/common';
import constants, { encryptedMarketplaceId } from '@/constants';
import { API_RESPONSE_STATUS_CODE } from '@/configs/common';
import { getKeywordHighlightPart, getCouponThresholdDescription } from '@/views/couponsList/config';
import { Bridge } from '@/utils/bridge';
import { showToast } from 'vant';
import { COUPON_STATUS, DEFAULT_SHOWN_COUPON_NUM, IS_AUTHENTICATED, PROMOTION_SUB_CATEGORY } from '@/configs/views/couponWidget';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { useLess } from '@/models/hooks';
import { useRoute } from 'vue-router';
export default {
  __name: 'CouponWidget',
  props: {
    properties: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  emits: ['updateSlideHeight'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/landingPage/couponWidget/CouponWidget.less');
    const route = useRoute();
    const {
      t
    } = useI18n();
    const couponListContainerRef = ref();
    const isShowAllCoupon = ref(false);
    const couponList = ref([]);
    const cptCouponListStyle = computed(() => {
      if (couponList.value.length > DEFAULT_SHOWN_COUPON_NUM && !isShowAllCoupon.value) {
        var _couponListContainerR, _couponListContainerR2, _couponListContainerR3, _couponListContainerR4;
        const couponItem = (_couponListContainerR = couponListContainerRef.value) === null || _couponListContainerR === void 0 ? void 0 : (_couponListContainerR2 = _couponListContainerR.children) === null || _couponListContainerR2 === void 0 ? void 0 : _couponListContainerR2[0];
        const couponItemSecond = (_couponListContainerR3 = couponListContainerRef.value) === null || _couponListContainerR3 === void 0 ? void 0 : (_couponListContainerR4 = _couponListContainerR3.children) === null || _couponListContainerR4 === void 0 ? void 0 : _couponListContainerR4[1];
        const space = (couponItemSecond === null || couponItemSecond === void 0 ? void 0 : couponItemSecond.offsetTop) - (couponItem === null || couponItem === void 0 ? void 0 : couponItem.offsetTop) - (couponItem === null || couponItem === void 0 ? void 0 : couponItem.clientHeight) || 0;
        return {
          height: `${((couponItem === null || couponItem === void 0 ? void 0 : couponItem.clientHeight) + space) * DEFAULT_SHOWN_COUPON_NUM}px`
        };
      }
      return {
        height: 'auto'
      };
    });
    const filterPromotionStatus = promotionStatus => {
      return Object.keys(promotionStatus).reduce((result, key) => {
        if (promotionStatus[key] !== COUPON_STATUS.UNKNOWN) {
          result[key] = promotionStatus[key];
        }
        return result;
      }, {});
    };
    const cptCouponWidgetStyle = computed(() => {
      return {
        paddingBottom: props.properties.bottomSpacing
      };
    });
    const handleCouponData = data => {
      const isFreeShipping = data.promotionSubCategory === PROMOTION_SUB_CATEGORY.FST;
      const termOfValidity = `${constants.formatTimestamp(data.startDate, 'date', '/')} - ${constants.formatTimestamp(data.endDate, 'date', '/')}`;
      if (isFreeShipping) {
        return {
          priceText: t('modules.couponsList.FREE_SHIPPING'),
          description: t('modules.couponsList.ZERO_THRESHOLD_FREE_SHIPPING'),
          requirement: '',
          isShowCurrencyUnit: false,
          termOfValidity
        };
      }
      return {
        priceText: getKeywordHighlightPart(data),
        description: getCouponThresholdDescription(data),
        requirement: t('modules.couponsList.ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION'),
        isShowCurrencyUnit: true,
        termOfValidity
      };
    };
    const getCouponList = async (couponIds, isLogin, data) => {
      if (!couponIds.length) {
        couponList.value = [];
        return;
      }
      const {
        data: {
          miniAppPromotionList: promotionList
        }
      } = await getPromotionInfosByPromotionIds(couponIds);
      const list = [];
      promotionList.forEach(item => {
        list.push({
          ...item,
          status: isLogin ? data[item.encryptedPromotionId] : COUPON_STATUS.ACTIVE,
          ...handleCouponData(item)
        });
      });
      couponList.value = list;
    };
    const getCouponInfo = async () => {
      try {
        const {
          data: promotionStatus
        } = await getPromotionStatusByPromotionIds(`${convertListToQueryParameter(props.properties.couponIds, 'promotionIdList')}&encryptedMarketplaceId=${encryptedMarketplaceId}`);
        const promotionStatusObj = filterPromotionStatus(promotionStatus);
        getCouponList(Object.keys(promotionStatusObj), true, promotionStatusObj);
      } catch (error) {
        console.error('error--api---getPromotionStatusByPromotionIds');
      }
    };
    const getCouponInfoNotAuthenticated = async () => {
      getCouponList(props.properties.couponIds, false);
    };
    onMounted(() => {
      Bridge.callFn(IS_AUTHENTICATED, {}, ({
        result
      }) => {
        if (result) {
          getCouponInfo();
        } else {
          getCouponInfoNotAuthenticated();
        }
      });
      const recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.couponWidgetWidget,
        ...recordParams
      });
    });
    const handleRedeemPromotion = promotionId => {
      awsRumHandler.recordClickEvent({
        ...clickEvents.landingPage.claimCouponButton,
        couponid: promotionId
      });
      Bridge.callFn(IS_AUTHENTICATED, {}, async ({
        result
      }) => {
        if (result) {
          try {
            const {
              data
            } = await redeemPromotionForCurrentCustomer({
              encryptedPromotionId: promotionId,
              encryptedMarketId: encryptedMarketplaceId
            });
            if (data.status === API_RESPONSE_STATUS_CODE.SUCCESS.toString()) {
              showToast({
                message: t('modules.couponsList.CLAIMED_SUCCESSFULLY'),
                icon: constants.SUCCESS_ICON_IMAGE_URL,
                overlay: false,
                overlayClass: 'a-overlay-white',
                className: 'a-toast'
              });
            }
            getCouponInfo();
          } catch (error) {
            console.error(error, 'api---error---redeemPromotionForCurrentCustomer');
          }
        } else {
          Bridge.callFn('startLogin', {}, () => {});
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", {
        class: "coupon-widget",
        style: _normalizeStyle(cptCouponWidgetStyle.value)
      }, [couponList.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "coupon-widget-list",
        style: _normalizeStyle(cptCouponListStyle.value),
        ref_key: "couponListContainerRef",
        ref: couponListContainerRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(couponList.value, item => {
        return _openBlock(), _createBlock(CouponItem, {
          key: item.encryptedPromotionId,
          couponItem: item,
          couponConfig: __props.properties,
          onHandleRedeemPromotion: $event => handleRedeemPromotion(item.encryptedPromotionId)
        }, null, 8, ["couponItem", "couponConfig", "onHandleRedeemPromotion"]);
      }), 128))], 4), couponList.value.length > _unref(DEFAULT_SHOWN_COUPON_NUM) && !isShowAllCoupon.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "see-more",
        onClick: _cache[0] || (_cache[0] = () => (isShowAllCoupon.value = true, emit('updateSlideHeight', true)))
      }, [_createTextVNode(_toDisplayString(_unref(t)('modules.couponsList.SEE_MORE')) + " ", 1), _createVNode(_component_van_icon, {
        name: "arrow-down"
      })])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 4);
    };
  }
};